import { QueryClientProvider } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { Toaster } from "sonner";
import { queryClient } from "@/lib/queryClient";

export function QueryProvider({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/* Single Toaster for the whole app — used by mutations (UC-10.05). */}
      <Toaster
        theme="dark"
        position="bottom-right"
        duration={4000}
        closeButton
        richColors
      />
    </QueryClientProvider>
  );
}
